import { api } from "api/api";
import {
    BookAppointmentOnlineDashboardModel
} from "models/BookAppointmentOnlineModel/BookAppointmentOnlineDashboard.model";

export interface ImageDTO {
    id: string;
    thumbnailUrl: string;
}

export interface ListDTO {
    title: string;
    subtitle?: string;
    priceFrom?: string;
    priceTo?: string;
    durationFrom?: string;
    durationTo?: string;
    context: CONTEXT_TYPES;
    contextId: string;
    images?: ImageDTO[];
}
export interface AddressDTO {
    companyName: string;
    street: string;
    zipCode: string;
    city: string;
}
export interface DashboardDTO {
    logo: string;
    address: AddressDTO;
    about: string;
    list: Array<ListDTO>;
}

export enum CONTEXT_TYPES {
    CONTEXT_DOCTOR = "DOCTOR",
    CONTEXT_SERVICE = "SERVICE",
    CONTEXT_ALL = "ALL",
}

export default async function getDashboard(): Promise<BookAppointmentOnlineDashboardModel> {
    const url = `api/public/book/appointment/online/dashboard`;
    const response = await api.get(url);
    return new BookAppointmentOnlineDashboardModel(response.data.data);
};
